module.exports = __webpack_public_path__ + "img/UZ.4a34d02a.png";